const dinner_menu = [
    {
      name: "General Tso's Chicken",
      link: "https://google.com",
      image: "/photos/david.jpg",
      allergies: ["chicken","gluten"],
      description: "Sweet and tangy battered chicken, glazed in a spicy sauce with a hint of garlic."
    },
    {
      name: "Salt and Pepper Pork",
      link: "https://google.com",
      image: "/photos/david.jpg",
      allergies: ["pork", "gluten"],
      description: "Crispy pork pieces tossed with salt, pepper, chili, and fragrant scallions."
    },
    {
      name: "Dragon and Phoenix",
      link: "https://google.com",
      image: "/photos/david.jpg",
      allergies: ["shellfish"],
      description: "Savory shrimp sautéed with garlic served with baby corn and other vegetables."
    },
    {
      name: "Brisket",
      link: "https://google.com",
      image: "/photos/david.jpg",
      allergies: ["beef"],
      description: "Slow-roasted beef brisket, melt-in-your-mouth tender with rich sauce."
    },
    {
      name: "Stir-Fried Green Beans with Mushrooms",
      link: "https://google.com",
      image: "/photos/david.jpg",
      allergies: [],
      description: "Crisp green beans and earthy mushrooms sautéed. (Vegetarian)"
    },
    {
      name: "Imperial Fried Rice",
      link: "https://google.com",
      image: "/photos/david.jpg",
      allergies: ["pork", "chicken"],
      description: "Savory rice stir-fried with veggies with sauteed pork and chicken."
    },
    {
      name: "Steamed Jasmine Rice",
      link: "https://google.com",
      image: "/photos/david.jpg",
      allergies: [],
      description: "Plain white rice to compliment and contrast with the meal."
    },

  ];
  

// const dinner_menu = [{
//     name: "TBD",
//     link: "https://google.com",
//     image: "/photos/david.jpg",
//     allergies: [],
//     description: "Coming Soon!"
// },
// ]
export default dinner_menu